import { defineEvent } from '../types/event';
export var EMAIL_UNSUBSCRIBE = defineEvent({
    platforms: [{ name: 'GTM', alias: 'unsubscribe_email' }]
});
